import { create } from 'zustand';

import {
  type AdminUserActions,
  type AdminUserState,
  createAdminUserActions,
  initialAdminUserState,
} from './actions/adminUser.action';

interface AdminStoreState extends AdminUserActions {
  user: AdminUserState;
}

const useAdminStore = create<AdminStoreState>()((set) => ({
  user: initialAdminUserState,
  ...createAdminUserActions(set),
}));

export type { AdminStoreState };
export { useAdminStore };
